"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMouseEvent = exports.browserIsSafariDesktop = exports.browserIsSafari = exports.browserIsAndroid = exports.walkElementHierarchyUp = exports.transitionNumber = exports.rectContainsPoint = exports.parametricBlend = exports.easeOutQuartic = exports.clampCenterOfLength = exports.clamp = exports.generateRandomId = void 0;
let idSuffix = 0;
/**
 * This id should be safe to use as a class name. So don't use any special
 * characters that CSS might get confused by.
 */
const generateRandomId = () => Math.random().toString(36).slice(2) + '_' + ++idSuffix;
exports.generateRandomId = generateRandomId;
function clamp(value, bounds) {
    if (bounds) {
        const [min, max] = bounds;
        if (min !== undefined && value < min) {
            return min;
        }
        if (max !== undefined && value > max) {
            return max;
        }
    }
    return value;
}
exports.clamp = clamp;
function clampCenterOfLength(centerValue, 
// Length of space that the center value is in.
length, bounds) {
    if (bounds) {
        const [min, max] = bounds;
        if (min !== undefined && max !== undefined && centerValue - length / 2 < min && centerValue + length / 2 > max) {
            // Return center of space
            return min + (max - min) / 2;
        }
        if (min !== undefined && centerValue - length / 2 < min) {
            return min + length / 2;
        }
        if (max !== undefined && centerValue + length / 2 > max) {
            return max - length / 2;
        }
    }
    return centerValue;
}
exports.clampCenterOfLength = clampCenterOfLength;
function easeOutQuartic(percent) {
    const a = 1 - percent;
    const b = 1 - a * a * a * a;
    return b;
}
exports.easeOutQuartic = easeOutQuartic;
function parametricBlend(percent) {
    const a = percent * percent;
    return a / (2.0 * (a - percent) + 1.0);
}
exports.parametricBlend = parametricBlend;
function rectContainsPoint(clientRect, x, y) {
    return clientRect.left < x && clientRect.right > x && clientRect.top < y && clientRect.bottom > y;
}
exports.rectContainsPoint = rectContainsPoint;
function transitionNumber(start, end, percent) {
    return start + (end - start) * percent;
}
exports.transitionNumber = transitionNumber;
function* walkElementHierarchyUp(leafElement) {
    let e = leafElement;
    while (e) {
        yield e;
        e = e.parentElement;
    }
}
exports.walkElementHierarchyUp = walkElementHierarchyUp;
exports.browserIsAndroid = navigator.userAgent.match(/Android/);
exports.browserIsSafari = navigator.vendor.match(/Apple/);
exports.browserIsSafariDesktop = exports.browserIsSafari && typeof Touch === 'undefined';
function isMouseEvent(e) {
    return e.touches === undefined;
}
exports.isMouseEvent = isMouseEvent;
//# sourceMappingURL=utils.js.map